import {
    ELicenseType,
    License,
    Physician,
    Service,
    LocalSEOInfoServer,
    EditLocalSEOInfoServer,
    TProfileLinkInfo,
    EServiceType,
    EListStatus,
    TInsurance,
    InsuranceSetting,
    PracitceAddressForm,
    CouponType,
    ISales,
    ISalesLinkCheckout,
} from './common';
import { FormPhysician, FormLicense, FormIdentify } from 'types/form';
import {
    AddtionalList,
    HealthcareExperienceFieldEnum,
    ProviderChannelEducation,
    ProviderChannelHealthcareExperience,
} from 'types/channelApplicationProvider';
import {
    EAgreementReviewType,
    TSubscriptionItem,
    TSubscriptionItemFromServer,
    TSubscriptionType,
} from './subscription';
import { EProfileStatus, MyChannelsData } from './channel';
import { EBindType } from './salesProvider';
import dayjs, { Dayjs } from 'dayjs';
import { ESource } from './operation';
import { EPPAStep } from 'types/ppaOnboarding';
import { TInvoiceLineItemDetail } from './invoice';
import { EInvitedProviderStep } from 'pages/InvitedProviderOnboarding/steps';

interface IChannelListChannel {
    id: number;
    name: string;
}

export enum EProviderInfoStatus {
    IN_PROGRESS = 'In-Progress',
    FINISHED_SIGN_UP = 'Finished Sign-up',
    SUBMITTED_APPLICATION = 'Submitted Application',
    APPLICATION_ON_HOLD = 'Application on-hold',
    APPLICATION_APPROVED = 'Application approved',
    BP_ACCOUNT_ENTERED = 'BP Account Entered',
}
export interface IproviderCreate {
    email?: string;
    firstName?: string;
    gmail?: string;
    lastName?: string;
    tel?: string;
}

export interface ProviderBasicInfo {
    id: number;
    address: string;
    specialityInHealth: string; //'ADHD,Anxiety',
    specialityInFamily: string; //'ADHD,Anxiety',
    npi?: string;
    state: string;
    title?: string;
    yearExp: number;
    tel?: string;
    zip: string;
    status?: EProviderInfoStatus;
    email?: string;
    gmail?: string;
    gmailPassword?: string;
    editable?: string;
    createTime?: string;
    firstName: string;
    middleName?: string;
    lastName: string;
    city?: string;
    refreshToken?: string;
    intakeqProviderId?: string;
    levelType?: string;
    photo: string;
    credential: string;
    useIntegrationUrl?: boolean;
    appointmentIntegrationUrl?: string;
    providerUid?: string;
}

export type Provider = ProviderBasicInfo & {
    licenseList?: License[];
    physicianData?: Physician[];
    googleAvatar?: string;
};

type Modify<T, R> = Omit<T, keyof R> & R;

export type ProviderVideo = {
    cover: string;
    url: string;
    id?: number;
    youtubeId?: string;
    isDefault: boolean;
};

export type ProviderProfile = Modify<
    ProviderBasicInfo,
    {
        title?: string;
        intro?: string;
        primaryLanguage?: string;
        foreignLanguage?: string[];
        inPersonChecked?: boolean;
        officeAddress?: string;
        officeCity?: string;
        officeState?: string;
        officeZip?: string;
        payout?: string;
        payment?: string;
        showReview?: boolean;
        allowAuth?: boolean;
        photoList?: string[];
        additionalPhotoList?: string[];
        inPersonVisitList?: unknown[];
        telehealthVisitList?: unknown[];
        licenses?: string[]; //nurse string display?
        status?: string;
        listStatus?: string;
        auditStatus?: string;
        updateStatus?: string;
        photo?: string;
        website?: string;
        middleName?: string;
        headLine?: string;
        headLines?: string[];
        credential?: string[];
        specialityInHealth: string[];
        specialityInFamily: string[];
        npiNotRequired: boolean;
        hasEhrAccountPwd?: boolean;
        product?: string;
        channelPreference?: string;
        signUpFrom?: ESource;
        headLineList?: string[];
        videoList?: ProviderVideo[];
        googleChannel: boolean;
        needAccount: boolean;
        channelMappingAccount: string;
        channelMappingPassword: string;
        googleTitle: string;
        account?: string;
        password?: string;
        virtualGmail?: string;
    }
>;

export type ProviderListItem = ProviderBasicInfo;

export enum ProfileFormFieldEnum {
    EMAIL = 'email',
    GMAIL = 'gmail',
    TEL = 'tel',
    MAILING_ADDRESS = 'address',
    CITY = 'city',
    ZIP_CODE = 'zip',
    STATE = 'state',
    NPI_NUMBER = 'npi',
    YEARS_OF_EXPERIENCE = 'yearExp',
    SPECIALITYINHEALTH = 'specialityInHealth',
    SPECIALITYINFAMILY = 'specialityInFamily',
}

export interface ProfileFormInterface {
    [ProfileFormFieldEnum.EMAIL]: string;
    [ProfileFormFieldEnum.GMAIL]?: string;
    [ProfileFormFieldEnum.TEL]: string;
    [ProfileFormFieldEnum.MAILING_ADDRESS]: string;
    [ProfileFormFieldEnum.CITY]: string;
    [ProfileFormFieldEnum.ZIP_CODE]: string;
    [ProfileFormFieldEnum.STATE]: string;
    [ProfileFormFieldEnum.NPI_NUMBER]: string;
    [ProfileFormFieldEnum.YEARS_OF_EXPERIENCE]: number;
    [ProfileFormFieldEnum.SPECIALITYINHEALTH]: string[];
    [ProfileFormFieldEnum.SPECIALITYINFAMILY]: string[];
}

export enum QualificationFormFieldEnum {
    STATE = 'state',
    DEA_LICENSES = 'deaLicense',
    NURSE_AND_PHYSICIAN_ASSISTANT_LICENSES = 'nurseAndPhysicianAssistantLicenses',
    CONTROLLED_SUBSTANCE_CERTIFICATION = 'controlledSubstanceCertification',
    CONTINUING_MEDICAL_EDUCATION_CERTIFICATES = 'continuingMedicalEducationCertificates',
    COLLABORATING_PHYSICIAN = 'collaboratingPhysician',
}

export type NurseAndPaFormLicenses = {
    nurse?: Partial<FormLicense>;
    pa?: Partial<FormLicense>;
};

export type NurseAndPaLicenses = {
    nurse?: Partial<License>;
    pa?: Partial<License>;
};

export type FormMutipleLicense = {
    licenses?: Partial<FormLicense | FormLicenseShadow>[];
    needLicense?: string;
};

export type MutipleLicense = {
    licenses?: Partial<License>[];
};

export interface QualificationFormFieldEnumInterface {
    [QualificationFormFieldEnum.STATE]: string;
    [QualificationFormFieldEnum.DEA_LICENSES]: FormMutipleLicense;
    [QualificationFormFieldEnum.NURSE_AND_PHYSICIAN_ASSISTANT_LICENSES]: NurseAndPaFormLicenses;
    [QualificationFormFieldEnum.CONTROLLED_SUBSTANCE_CERTIFICATION]: FormMutipleLicense;
    [QualificationFormFieldEnum.CONTINUING_MEDICAL_EDUCATION_CERTIFICATES]: FormMutipleLicense;
    [QualificationFormFieldEnum.COLLABORATING_PHYSICIAN]: FormPhysician;
}

export interface QualificationFieldEnumInterface {
    [QualificationFormFieldEnum.STATE]: string;
    [QualificationFormFieldEnum.DEA_LICENSES]: MutipleLicense;
    [QualificationFormFieldEnum.NURSE_AND_PHYSICIAN_ASSISTANT_LICENSES]: NurseAndPaLicenses;
    [QualificationFormFieldEnum.CONTROLLED_SUBSTANCE_CERTIFICATION]: MutipleLicense;
    [QualificationFormFieldEnum.CONTINUING_MEDICAL_EDUCATION_CERTIFICATES]: MutipleLicense;
    [QualificationFormFieldEnum.COLLABORATING_PHYSICIAN]: Physician;
}
export interface FormMutipleQualificationFormFieldEnumInterface {
    qualifications: Partial<QualificationFormFieldEnumInterface>[];
}

export interface PreviewFormInterface extends ProfileFormInterface, FormMutipleQualificationFormFieldEnumInterface {}

export type ProviderPractice = {
    id?: number;
    treatmentPhilosophy: string;
    treatmentApproach: string;
    practiceName: string;
    practiceAddress: string;
    practiceCity: string;
    practiceState: string;
    practiceZip: string;
    practiceEmail: string;
    practicePhone: string;
    practiceWebsite: string;
    companyType: string;
    practiceDesc: string;
    practiceLogo: string;
    specialityInFamily?: string[];
    specialityInHealth?: string[];
    practiceFrontUrl: string;
    specialtyList: string[];
    conditionTreatedList: string[];
    addressList?: Array<PracitceAddressForm>;
    notHaveName: boolean;
    notHavePhone: boolean;
    specialtyHighlightList?: string[];
    taxIdType: string;
    taxId: string;
    setUpLapOption: string;
    w9Form: string;
    vfdPhoneLine?: string;
};

export type ProviderExperience = {
    organizationName: string;
    title: string;
    startDate: string | Dayjs;
    endDate: string | Dayjs;
    employmentType: string;
    hospitalLocation: string;
    description: string;
    experienceLogo: string;
    currently: boolean;
};

export type ProviderEducation = {
    schoolName: string;
    major: string;
    degree: string;
    startDate: string;
    endDate: string;
    specialties: string;
    certificates: string;
    schoolLogo: string;
    currently: boolean;
    id: number;
};

export type AwardAdditional = {
    id: string;
    name: string;
    website: string;
    authors: string;
    additionType: string;
};

export type TKlarityServiceServerItemForPF = {
    serviceId: number;
    serviceSpecialtyName: string;
    serviceSpecialtyId: number;
    serviceTypeId: number;
    serviceType: EServiceType;
    displayName: string;
    providerId: number;
    customizedServiceName?: string;
    state: string; //'NY',
    duration: number;
    earning: number;
    patientCost: number;
    teleHealth: boolean;
    inPerson: boolean;
    appliedTeleHealth: boolean;
    appliedInPerson: boolean;
    groupAndLimitationId: number;
    qtyPatientGroup: number;
    qtyLimitation: number;
    allPatientGroup: boolean;
    avaPriceInsight?: number;
    serviceSpecialtyImage?: string;
    serviceDescription?: string;
    offeringId?: number;
    limitation?: string;
    patientGroup?: string;
    description: string;
    priceUpdateAt: string;
    serviceSpecialtyDescription: string;
    intakeFormFlag?: boolean;
};

export type UniProfile = {
    appointmentIntegrationUrl: string;
    useIntegrationUrl: boolean;
    appointmentNewFlag: boolean | null;
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    tel: string;
    gmail: string;
    address: string;
    zip: string;
    state: string;
    city: string;
    status: string;
    editable: string;
    refreshToken: string;
    npi: string;
    yearExp: number;
    specialityInHealth: string;
    specialityInFamily: string;
    createTime: string;
    timezone: string;
    intakeqProviderId: string;
    providerId: number;
    channelId: number;
    title: string;
    intro: string;
    primaryLanguage: string;
    foreignLanguage: string[];
    payout: string;
    showReview: boolean;
    allowAuth: boolean;
    listStatus: string;
    auditStatus: string;
    photo: string;
    photoList: string[];
    additionalPhotoList: string[];
    providerServiceList: Service[];
    providerPractice: ProviderPractice;
    providerExperienceList: ProviderExperience[];
    providerEducationList: ProviderEducation[];
    associationAdditionalList: unknown[];
    awardAdditionalList: AwardAdditional[];
    publicationAdditionalList: [];
    licenseDtoList: Array<License>;
    credential: string;
    headLine: string;
    supportPayType: string;
    containSeoApp?: boolean;
    seoData?: Record<string, EditLocalSEOInfoServer>; //key is state
    pfKlarityServiceList?: TKlarityServiceServerItemForPF[];
};

export interface PFProvider extends Omit<UniProfile, 'providerServiceList'> {
    insuranceList: Array<string>;
    otherInsuranceList: Array<string>;
    channelList: Array<IChannelListChannel>;
    seoCity?: string;
    pfKlarityServiceList?: TKlarityServiceServerItemForPF[];
    providerServiceList: Array<{
        id?: number;
        colorId?: string;
        description?: string;
        duration?: number;
        name: string;
        personAddress?: string;
        personCity?: string;
        personState?: string;
        personType?: string[];
        personZip?: string;
        providerId?: number;
        sendForm?: string;
        telehealthType?: string[];
        type?: string;
        price?: number;
        intakeForm: string;
    }>;
}

export type ProviderLicenseFromData = {
    state: string;
    [ELicenseType.DEA]?: Array<FormLicense>;
    [ELicenseType.CONTINUING_MEDICAL_EDUCATION_CERTIFICATES]?: Array<FormLicense>;
    [ELicenseType.CONTROLLED_SUBSTAN_CECERTIFICATION]?: Array<FormLicense>;
    [ELicenseType.PRACTICE]?: Array<FormLicense>;
};

export type ProviderLicenseFromDataWithoutState = {
    [ELicenseType.DEA]?: Array<FormLicense>;
    [ELicenseType.CONTINUING_MEDICAL_EDUCATION_CERTIFICATES]?: Array<FormLicense>;
    [ELicenseType.CONTROLLED_SUBSTAN_CECERTIFICATION]?: Array<FormLicense>;
    [ELicenseType.PRACTICE]?: Array<FormLicense>;
};

export type ProviderPhysicianFromData = {
    state: string;
    collaboratingPhysician?: FormPhysician;
};

export interface IContract {
    contractId: number;
    contractPlanId?: number;
    contractPlanName?: string;
    contractSignAddress: string;
    contractSignAt: string;
    contractSignDate: string;
    contractSignName: string;
    contractSignUrl: string;
    contractVersion: string;
    providerId: number;
    sourceId: number;
    sourceType: string;
}

export type ServiceExt = Service & { inpersonChecked: boolean; telehealthChecked: boolean };

export type ServiceExtShadow = ServiceExt & {
    isNewAdd?: boolean;
    isDeleted?: boolean;
    descriptionNew?: string;
    durationNew?: number;
    nameNew?: string;
    personAddressNew?: string;
    personCityNew?: string;
    personStateNew?: string;
    personTypeNew?: string;
    personZipNew?: string;
    priceNew?: number;
    lowestPriceNew?: number;
    highestPriceNew?: number;
};

export type TPreviousListing = {
    id: number;
    providerId: number;
    channelName: string; // "Psychology Today",
    channelId: number;
    account: string; // "evanliu.it2@gmail.com",
    password: string;
    createAt: string; //"2024-07-09T00:43:38.000+00:00",
    createBy: number;
    updateAt: string; //"2024-07-09T00:43:38.000+00:00",
    updateBy: number; // 51
};

// listingStatus:
// PR: pending Review 代表从来没有上线过
// L: 已经上线
// U: 上线后,又下线
// PL: 上线后, 又 pause listed

export enum EProviderListStatus {
    PR = 'PR',
    L = 'L',
    U = 'U',
    PL = 'PL',
}

export type UniprofileFormData = {
    id: number;
    assignee?: string;
    notes?: string;
    listChannelCount?: number;
    profile: Partial<ProviderProfile>;
    profileLinks?: string[];
    profileLinkInfo?: TProfileLinkInfo[];
    services: ServiceExt[];
    practice: ProviderPractice;
    experienceList: Array<ProviderChannelHealthcareExperience>;
    educationList: Array<ProviderChannelEducation>;
    conversationId?: string;
    previousListings?: TPreviousListing[];
    signUpFrom?: ESource;
    appointmentIntegrationUrl?: string;
    avaAutoReply?: boolean;
    channelPassword?: string;
    channelAccount?: string;
    listingType?: 'M' | 'L';
    documentId?: string;
    deaLicensePrescribeStatus?: string;
    expectLaunchTime?: string;
    addtional: {
        payout: string;
        showReview: boolean;
        associationAdditionalList: Array<AddtionalList>;
        awardAdditionalList: Array<AddtionalList>;
        publicationAdditionalList: Array<AddtionalList>;
    };
    insurance: {
        insurances: InsuranceSetting[];
        supportPayType: string;
        supportPayTypeNew?: string;
    };
    biographic: {
        ethnicity: string;
        birthDate: string;
        gender: string;
        religion: string;
        usedName: string;
    };
    licenses?: ProviderLicenseFromDataWithoutState;
    licensesInState?: ProviderLicenseFromData[];
    malpracticeInsuranceCertificate?: FormLicense;
    physicians?: FormPhysician[];
    seoCity?: string[];
    containSeoApp?: boolean;
    seoData?: Record<string, EditLocalSEOInfoServer>; //key is state
    payPlan?: TSubscriptionItemFromServer;
    listedChannels?: MyChannelsData;
    source?: 'A' | 'E' | 'K';
    contractList?: IContract[];
    identificationList?: FormIdentify[];
    tags?: string[];
    prescribableMedications?: string[];
    nonPrescribableMedications?: string[];
    medications?: {
        state: string;
        nonPrescribableMedications: string[];
        prescribableMedications: string[];
        syncAllState: boolean;
    }[];
    listingStatus: EProviderListStatus;
};

export enum EPayProviderListType {
    ESSENTIAL = 'Essential',
    HELLO_KLARITY = 'Klarity',
    GROWTH = 'Growth',
    CHANNEL = 'channel',
    KLARITY_E_PRESCRIPTIONS = 'KLARITY_E_PRESCRIPTIONS',
    KLARITY_E_FAX = 'KLARITY_E_FAX',
}

export enum EFeatureType {
    TEXT_VISIT = 'TEXT_VISIT',
    KLARITY_PPA_AUTO_LISTING_DISABLED = 'KLARITY_PPA_AUTO_LISTING_DISABLED',
    KLARITY_PORTAL = 'KLARITY_PORTAL',
    PROLISTING_REPORT = 'PROLISTING_REPORT',
    KLARITY_MEETING = 'KLARITY_MEETING',
    VISIT_FOLLOW_UP_REMINDER_OFF = 'VISIT_FOLLOW_UP_REMINDER_OFF',
    KLARITY_CREDENTIALING = 'KLARITY_CREDENTIALING',
    KLARITY_INSURANCE_BILLING = 'KLARITY_INSURANCE_BILLING',
    KLARITY_VERIFIED_PLUS = 'KLARITY_VERIFIED_PLUS',
    // Ops 在 All providers 打开：该账号（group 看 owner）credentialing 押金全免，后端建 $0 SUCCEEDED 账单
    CREDENTIALING_FEE_WAIVED = 'CREDENTIALING_FEE_WAIVED',
}

export type HomeInfo = {
    firstChannelCompleted: boolean;
    practiceFrontCompleted: boolean;
    practiceAndPaymentSetUpCompleted: boolean;
    uniprofileApproved: boolean;
    uniprofileSubmitted: boolean;
    uniprofileApproveCompleted: boolean;
    ehrSetUpCompleted: boolean;
    agreementReviewTypeList: EAgreementReviewType[];
    klarityStarterSetUpCompleted?: boolean;
    klarityUser?: boolean;
    klarityUserWithoutKiwiPlan?: boolean;
    freeUser?: boolean;
    providerPlan?: TSubscriptionItemFromServer;
    signUpFrom?: ESource;
    uniprofileStatus: EProfileStatus;
    addOnPaid?: boolean;
    firstLoginAt?: string;
    firstUniprofileApprovedAt?: string;
    firstUniprofileSubmitAt?: string;
    firstPracticeLaunchAt?: string;
    firstAddOnPaidAt?: string;
    ehrSetUpCompletedAt?: string;
    completedOnboarding?: boolean;
    signUpDate?: string;
    isRegularUser?: boolean;
    uidPublic?: string;
    ppaProvider?: boolean;
    ppvProvider?: boolean;
    providerCalendlyScheduleRecords?: string[];
    availabilitySetUpCompleted?: boolean;
    klarityServiceSetUpCompleted?: boolean;
    klarityListed?: boolean;
    listingStatus?: string;
    providerTypes?: 'KLARITY_PORTAL' | 'KIWI_PORTAL'[];
    expectLaunchAt?: string;
    klarityOnboardingStep?: EPPAStep | EInvitedProviderStep;
    payProviderList?: EPayProviderListType[];
    features?: EFeatureType[];
    proListing?: boolean;
    providerFailedChargeTypes?: string[]; //"LEAD_GEN_FEE","PRO_LISTING_FEE"
    slugName?: string;
    notificationTypes?: string[]; // 通知类型数组，如 ["NEW_TEXT_VISIT"]
};

export interface IUpdatePasswordFormData {
    email: string;
    password: string;
    oldPassword: string;
}

export interface IUpdateTelFormData {
    tel: string;
}

export interface ICommonFormData extends ServiceExt {
    hasSetPrice: boolean;
    hasSetMeetingType: boolean;
}

export enum PartOfNameEnmu {
    FIRSTNAME = 'firstName',
    LASTNAME = 'lastName',
}

export interface ISalesProvider {
    accountReview: {
        emailList: string[];
        accountStatus: EBindType;
        loginEmail?: string;
        verify?: boolean;
    };
    currentStep: string;
    linkId: number;
    linkStatus: string;
    linkUuid: string;
    sales: ISales;
    checkOut: ISalesLinkCheckout;
    agreement: {
        contractId: number;
        contractUrl: string;
    };
    fullName?: string;
}

export interface ISalesCreateNewAccount {
    email: string;
    password?: string;
}

export type ProviderProfileShadow = Partial<ProviderProfile> &
    Partial<{
        // title?: string,
        // intro?: string,
        // primaryLanguage?: string,
        // foreignLanguage?: string[],
        // inPersonChecked?: boolean,
        // officeAddress?: string,
        // officeCity?: string,
        // officeState?: string,
        // officeZip?: string,
        // payout?: string,
        // payment?: string,
        // showReview?: boolean,
        // allowAuth?: boolean,
        // photoList?: string[],
        // additionalPhotoList?: string[],
        // inPersonVisitList?: unknown[],
        // telehealthVisitList?: unknown[],
        // licenses?: string[], //nurse string display?
        // status?: string,
        // listStatus?: string,
        // auditStatus?: string,
        // updateStatus?: string,
        // photo?: string,
        // website?: string,
        // middleName?: string,
        // headLine?: string,
        // credential?: string[],
        // specialityInHealth: string[],
        // specialityInFamily: string[],
        // npiNotRequired: boolean,
        titleNew?: string;
        introNew?: string;
        primaryLanguageNew?: string;
        officeAddressNew?: string;
        officeCityNew?: string;
        officeStateNew?: string;
        officeZipNew?: string;
        payoutNew?: string;
        paymentNew?: string;
        photoNew?: string;
        websiteNew?: string;
        middleNameNew?: string;
        headLineNew?: string;

        foreignLanguageNew?: string[];
        photoListNew?: string[];
        additionalPhotoListNew?: string[];
        licensesNew?: string[]; //nurse string display?
        credentialNew?: string[];
        specialityInHealthNew: string[];
        specialityInFamilyNew: string[];
    }>;

// export enum HealthcareExperienceFieldEnum {
//     ORGANIZATION_NAME = 'organizationName',
//     TITLE = 'title',
//     IS_CURRENTLY_WORK = 'currently',
//     START_DATE = 'startDate',
//     END_DATE = 'endDate',
//     EMPLOYMENT_TYPE = 'employmentType',
//     HOSPITAL_LOCATION = 'hospitalLocation',
//     DESCRIPTION = 'description',
//     LOGO = 'experienceLogo',
// }

export type ProviderChannelHealthcareExperienceShadow = ProviderChannelHealthcareExperience &
    Partial<{
        // [HealthcareExperienceFieldEnum.ORGANIZATION_NAME]: string,
        // [HealthcareExperienceFieldEnum.TITLE]: string,
        // [HealthcareExperienceFieldEnum.IS_CURRENTLY_WORK]: boolean,
        // [HealthcareExperienceFieldEnum.START_DATE]: string,
        // [HealthcareExperienceFieldEnum.END_DATE]: string,
        // [HealthcareExperienceFieldEnum.EMPLOYMENT_TYPE]: string,
        // [HealthcareExperienceFieldEnum.HOSPITAL_LOCATION]: string,
        // [HealthcareExperienceFieldEnum.DESCRIPTION]: string,
        // [HealthcareExperienceFieldEnum.LOGO]: string,
        organizationNameNew: string;
        titleNew: string;
        currentlyNew: boolean;
        startDateNew: string;
        endDateNew: string;
        employmentTypeNew: string;
        hospitalLocationNew: string;
        descriptionNew: string;
        experienceLogoNew: string;
    }>;

export type FormLicenseShadow = FormLicense &
    Partial<{
        // id: number,
        // providerId: number,
        // type: string,
        // secondType: string,
        // state: string,
        // licenseNumber: string,
        // expireDate?: dayjs.Dayjs,
        // schedule: string[],
        // url?: string,
        // certificatedTitle?: string,
        // classTitle?: string,
        // hourCompleted?: number,
        // licenseType?: Record<string, string | Record<string, string>> // others wiil be string
        isNewAdd?: boolean;
        isDeleted?: boolean;
        typeNew?: string;
        secondTypeNew?: string;
        stateNew?: string;
        licenseNumberNew?: string;
        expireDateNew?: string;
        urlNew?: string;
        certificatedTitleNew?: string;
        classTitleNew?: string;
        hourCompletedNew?: number;
        scheduleNew?: string[];
    }>;

export type ProviderLicenseFromDataWithoutStateShadow = {
    [ELicenseType.DEA]?: Array<FormLicenseShadow>;
    [ELicenseType.CONTINUING_MEDICAL_EDUCATION_CERTIFICATES]?: Array<FormLicenseShadow>;
    [ELicenseType.CONTROLLED_SUBSTAN_CECERTIFICATION]?: Array<FormLicenseShadow>;
    [ELicenseType.PRACTICE]?: Array<FormLicenseShadow>;
};

export type ProviderPracticeShadow = ProviderPractice &
    Partial<{
        treatmentPhilosophyNew: string;
        treatmentApproachNew: string;
        practiceNameNew: string;
        practiceAddressNew: string;
        practiceCityNew: string;
        practiceStateNew: string;
        practiceZipNew: string;
        practiceEmailNew: string;
        practicePhoneNew: string;
        practiceWebsiteNew: string;
        companyTypeNew: string;
        practiceDescNew: string;
        practiceLogoNew: string;
        specialityInFamilyNew?: string[];
        specialityInHealthNew?: string[];
        specialtyListNew: string[];
        conditionTreatedListNew: string[];
    }>;

export type UniprofileFormDataShadow = UniprofileFormData & {
    profile: ProviderProfileShadow;
    practice: ProviderPracticeShadow;
    insurance: {
        insuranceList: Array<string>;
        insuranceListNew?: Array<string>;
        otherInsuranceList: string;
        otherInsuranceListNew?: string;
        supportPayType: string;
        supportPayTypeNew?: string;
    };
    licenses?: ProviderLicenseFromDataWithoutStateShadow;
    malpracticeInsuranceCertificate?: FormLicenseShadow;
    services: ServiceExtShadow[];
};

export interface IProvderAgreementSignFormData {
    type: TSubscriptionType;
    contractSignName: string;
    contractSignDate: dayjs.Dayjs;
    contractSignAddress: string;
}

export interface IProvderAgreementSignInput {
    type: TSubscriptionType;
    contractSignName: string;
    contractSignDate: string;
    contractSignAddress: string;
}

export interface IProvderAgreementSignResponse {
    contractId: number;
    contractPdfUrl: string;
    contractUrl: string;
    contractVersion: string;
    planType: TSubscriptionType;
}

export enum EProviderUniprofileStatus {
    PENDING_REVIEW = 'PR',
    LISTED = 'L',
    UNLISTED = 'U',
    DISQUALIFIED = 'D',
    UNIPROFILE_NEEDED = 'UN',
}

export enum EProviderType {
    KIWI = 'kiwi',
    KLARITY = 'klarity',
}
export enum EBillingStatusLabel {
    DISPUTE_OPEN = 'Dispute open',
    // DISPUTE_CLOSED = "Dispute closed",
    PENDING = 'Pending',
    // PAID = "Paid",
    FAILED = 'Failed',
    CANCELED = 'Canceled',
    // NOT_READY = "Not ready",
    PROCESSING = 'Processing',
    SUCCEEDED = 'Paid',
    REFUND_PROCESSING = 'Refund processing',
    REFUNDED = 'Refunded',
    REFUND_FAILED = 'Refund failed',
    DISPUTE_PROCESSING = 'Dispute processing',
    DISPUTE_WON = 'Dispute won',
    DISPUTE_LOST = 'Dispute lost',
    PATIENT_NOT_READY = 'Not ready',
    PROVIDER_NOT_READY = 'Not ready',
    NOT_READY = 'Not ready',
    SCHEDULED = 'Scheduled',
    SENT = 'Sent',
    PARTIAL_PAID = 'Partial paid',
    FULLY_PAID = 'Paid',
    PARTIAL_REFUNDED = 'Partial refunded',
    OVERDUE = 'Overdue',
    PAYMENT_FAILED = 'Payment failed',
}

export enum EBillingStatus {
    DISPUTE_OPEN = 'DISPUTE_OPEN',
    // DISPUTE_CLOSED = "DISPUTE_CLOSED",
    PENDING = 'PENDING',
    NOT_READY = 'NOT_READY',
    // PAID = "PAID",
    FAILED = 'FAILED',
    CANCELED = 'CANCELLED',
    // billing rows spell it with one L; CANCELED above is the invoice status
    BILLING_CANCELED = 'CANCELED',
    // NOT_READY = "NOT_READY",
    PROCESSING = 'PROCESSING',
    SUCCEEDED = 'SUCCEEDED',
    REFUND_PROCESSING = 'REFUNDED_PROCESSING',
    REFUNDED = 'REFUNDED',
    REFUND_FAILED = 'REFUNDED_FAILED',
    DISPUTE_PROCESSING = 'DISPUTE_PROCESSING',
    DISPUTE_WON = 'DISPUTE_WON',
    DISPUTE_LOST = 'DISPUTE_LOST',
    PATIENT_NOT_READY = 'PATIENT_NOT_READY',
    PROVIDER_NOT_READY = 'PROVIDER_NOT_READY',

    // invoice
    SCHEDULED = 'SCHEDULED',
    SENT = 'SENT',
    PARTIAL_PAID = 'PARTIAL_PAID',
    FULLY_PAID = 'FULLY_PAID',
    PARTIAL_REFUNDED = 'PARTIAL_REFUNDED',
    OVERDUE = 'OVERDUE',
    // invoice event-only (not a status transition; recorded per failed payment attempt)
    PAYMENT_FAILED = 'PAYMENT_FAILED',
}

export enum EBillingStatusDes {
    // DISPUTE_CLOSED = "DISPUTE_CLOSED",
    REFUND_PROCESSING = 'REFUNDED_PROCESSING',
    REFUND_FAILED = 'REFUND_FAILED',
    DISPUTE_OPEN = 'A patient has raised a dispute regarding a payment, and it is awaiting your review.',
    PENDING = 'The payment has been initiated and is awaiting completion.',
    // PAID = "PAID",
    FAILED = 'The payment attempt was unsuccessful due to an error or decline.',
    CANCELED = 'The payment or transaction has been canceled.',
    // NOT_READY = "Payment delayed because the patient has not completed necessary steps or provided required information.",
    PROCESSING = 'Payment is currently being processed and will finalize shortly.',
    SUCCEEDED = 'Payment has been successfully completed.',
    REFUNDED = 'Payment has been returned to the patient.',
    DISPUTE_PROCESSING = 'A payment dispute is currently under review by the payment provider.',
    DISPUTE_WON = 'The dispute has been resolved in your practice’s favor.',
    DISPUTE_LOST = ' The dispute has been resolved in the patient’s favor, and funds have been returned.',
    PROVIDER_NOT_READY = 'Payment delayed because your practice hasn’t completed necessary steps or provided required information. System will process again.',
    PATIENT_NOT_READY = 'Payment delayed because the patient has not completed necessary steps or provided required information. System will process again.',
}

export enum EInvoiceStatusDesc {
    SCHEDULED = 'This invoice has been created and will be sent to the patient on {scheduled date}.',
    SENT = 'This invoice has been sent to the patient, but payment has not been received yet.',
    PARTIAL_PAID = 'A portion of this invoice has been paid. The remaining balance will be charged later.',
    FULLY_PAID = 'The invoice has been fully paid.',
    PARTIAL_REFUNDED = 'The payment has been partially refunded.',
    OVERDUE = 'The due date has passed and payment has not been received.',
    CANCELLED = 'This invoice was canceled and can no longer be paid.',
}

// NO_SHOW("No Show"),

// LATE_CANCELLATION("Late Cancellation"),

// RESCHEDULE("Reschedule"),

// LEAD_GEN_FEE("Lead Gen Fee"),

// PARTIAL_PAYMENT("partial payment"),

// FULL_SELF_PAYMENT("full self-pay"),

// CO_PAY("Co-pay"),

// OTHER("other"),;

export enum EChargeTypeLabel {
    NO_SHOW = 'No Show',
    LATE_CANCELLATION = 'Late Cancellation',
    RESCHEDULE = 'Reschedule',
    LEAD_GEN_FEE = 'Lead Gen Fee',
    PARTIAL_PAYMENT = 'Partial payment',
    FULL_SELF_PAYMENT = 'Full self-pay',
    CO_PAY = 'Co-pay',
    OTHER = 'Other',
    TEXT_VISIT = 'Text visit',
    INVOICE = 'Invoice',
    // TODO: placeholder copy, pending Stacey
    PPA_BOOKING_DEPOSIT = 'Deposit',
    PPA_BOOKING_BALANCE = 'Balance',
}

export enum EChargeType {
    NO_SHOW = 'NO_SHOW',
    LATE_CANCELLATION = 'LATE_CANCELLATION',
    RESCHEDULE = 'RESCHEDULE',
    LEAD_GEN_FEE = 'LEAD_GEN_FEE',
    PARTIAL_PAYMENT = 'PARTIAL_PAYMENT',
    FULL_SELF_PAYMENT = 'FULL_SELF_PAYMENT',
    CO_PAY = 'CO_PAY',
    OTHER = 'OTHER',
    TEXT_VISIT = 'TEXT_VISIT',
    INVOICE = 'INVOICE',
    // PPA switch-to-self-pay billings, not attached to an invoice
    PPA_BOOKING_DEPOSIT = 'PPA_BOOKING_DEPOSIT',
    PPA_BOOKING_BALANCE = 'PPA_BOOKING_BALANCE',
}

// {
//     "id": 1,
//         "appointmentId": 207,
//         "providerId": 1287,
//         "clientId": 106437,
//         "relationId": 56,
//         "chargeType": "NO_SHOW",
//         "chargeFromId": 32,
//         "chargeFromType": "KLARITY_USER",
//         "chargeToId": 1287,
//         "chargeToType": "PROVIDER",
//         "billingStatus": "SUCCEEDED",
//         "preCheckAttempts": 1,
//         "paymentAttempts": 1,
//         "lastAttemptAt": "2025-04-28T10:00:54",
//         "nextAttemptAt": "2025-04-28T09:59:29",
//         "amountCents": 2500,
//         "stripeConnectAccountId": "acct_1REPMXPruyIGUHER",
//         "stripePaymentIntentId": "pi_3RIoUePruyIGUHER2ofvs6X6",
//         "stripeCustomerId": "cus_SDBoS5uuZunOKS",
//         "stripeChargeId": "",
//         "stripeCardLast4": "4242",
//         "chargeSucceedAt": "2025-04-28T10:00:59Z",
//         "errorCode": "",
//         "errorMessage": "",
//         "cancelReason": "",
//         "notReadyReason": "",
//         "chargeReason": "",
//         "createdAt": "2025-04-28T09:59:29Z",
//         "createdBy": 0,
//         "updatedAt": "2025-04-28T10:00:59Z",
//         "updatedBy": 0,
//         "refundAmountCents": 0,
//         "patientFirstName": "chen",
//         "patientLastName": "chen",
//         "payoutAmountCents": null,
//         "payoutAmount": null
// }

export enum TBillingFrom {
    KLARITY_USER_INVOICE = 'KLARITY_USER_INVOICE',
    PROVIDER_APPOINTMENT_BILLING = 'PROVIDER_APPOINTMENT_BILLING',
    KLARITY_USER_BILLING = 'KLARITY_USER_BILLING',
}

export type TCreateRefund = {
    billingId: number;
    refundAmount: number;
    reason?: string;
};

export type TCreateUnifiedRefund = {
    billingFrom: TBillingFrom;
    billingId: number;
    refundAmount: number;
    reason: string;
};

export type TPaymentBilling = {
    id: number;
    appointmentId: number;
    providerId: number;
    clientId: number;
    relationId: number;
    chargeType: EChargeType; //"FULL_SELF_PAYMENT";
    chargeFromId: number;
    chargeFromType: string; //"KLARITY_USER";
    chargeToId: number;
    chargeToType: EChargeType; //"PROVIDER";
    billingStatus: EBillingStatus; //"DISPUTE_OPEN";
    billingFrom: TBillingFrom;
    preCheckAttempts: number;
    paymentAttempts: number;
    lastAttemptAt: string; //"2025-07-01T09:00:31";
    nextAttemptAt: null;
    amountCents: number;
    stripeConnectAccountId: string; //"acct_1Rc5ofPsbSZsEsYJ";
    stripePaymentIntentId: string; //"pi_3Rg02pPsbSZsEsYJ0p2gYhAY";
    stripeCustomerId: string; //"cus_SQocapfFEWVWmf";
    stripeChargeId: string; //"ch_3Rg02pPsbSZsEsYJ0i1p3mtx";
    stripeCardLast4: string; //"0259";
    chargeSucceedAt: string; //"2025-07-01T09:00:23Z";
    errorCode: string; //"";
    errorMessage: '';
    cancelReason: string; //"";
    notReadyReason: string; //"";
    chargeReason: string; //"TEST";
    createdAt: string; //"2025-07-01T09:00:31Z";
    createdBy: number;
    updatedAt: string; //"2025-07-01T09:07:06Z";
    updatedBy: number;
    providerFirstName: string; //"autocharge";
    providerLastName: string; //"Test";
    providerAvatar: string; //"https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/1fa950fb-43b8-4f60-adcc-dc719abcb413.jpg";
    credential: string; //"LAADC-CA,ACNP,ACCNS-P";

    refundAmountCents: number; //0,
    // Max amount that can still be refunded; 0 = refund not available. Invoice rows sum their refundable billings.
    refundableAmountCents?: number;
    // Non-refundable Klarity PPV $10 deposit; > 0 shows the deposit note in the refund modal.
    depositExcludedCents?: number;
    patientFirstName: string; // "chen",
    patientLastName: string; // "chen",
    patientEmail: string; // "chen@example.com",
    payoutAmountCents: number | null;
    payoutAmount: number | null;

    issueDate?: string;
    dueDate?: string;
    invoiceNo?: string;
    lineItems?: TInvoiceLineItemDetail[];
    provider?: {
        avatar: string;
        firstName: string;
        lastName: string;
        providerId: number;
    };
    // Single composed provider name returned by the group practice "Practice View" endpoints.
    providerName?: string;
};

export type TPaymentEvent = {
    id: number;
    billingId: number;
    eventType: string;
    eventStatus: string;
    eventTime: string;
    operatorId: number;
    eventAmountCents?: number;
    eventId: string;
    eventReason: string;
    extraInfo: string;
    createdAt: string;
    eventAmount?: number;
};

// /provider/feedback 的采集来源枚举：后端封闭且大小写敏感（未知值返 91045），新页面接入前需后端先加枚举
export type TProviderFeedbackType = 'INSURANCE_BILLING_SUGGESTION';

export interface ProviderFeedbackCreateReq {
    type: TProviderFeedbackType;
    value: string;
    // 采集方自定义上下文，服务端原样存储不解析（JSON 仅为约定）
    metaData?: string;
}
